var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container" }, [
    _c(
      "div",
      { staticClass: "breadcrumb" },
      [
        _c(
          "el-breadcrumb",
          { attrs: { separator: "" } },
          [
            _c("el-breadcrumb-item", [
              _c("div", { staticClass: "div1" }, [_vm._v("商品管理")]),
            ]),
            _c("el-breadcrumb-item", [
              _c("div", { staticClass: "div2" }, [_vm._v("身份设置")]),
            ]),
          ],
          1
        ),
      ],
      1
    ),
    _c("div", { staticClass: "Box" }, [
      _c("div", { staticClass: "table_tab" }, [
        _vm._m(0),
        _c("div", { staticClass: "inquiryTab" }, [
          _c("div", { staticClass: "inquiryTab_average" }, [
            _c(
              "div",
              { staticClass: "table" },
              [
                _c(
                  "el-table",
                  {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.loading,
                        expression: "loading",
                      },
                    ],
                    ref: "theTable",
                    staticStyle: { width: "100%" },
                    attrs: {
                      data: _vm.tableData,
                      "header-cell-style": {
                        background: "#f8f8f8",
                        textAlign: "left",
                      },
                      toggleRowExpansion: { expanded: true },
                      "row-style": { height: "135px" },
                    },
                  },
                  [
                    _c("el-table-column", {
                      attrs: { label: "服务商名称", "min-width": "40" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (props) {
                            return [
                              _c("el-input", {
                                staticStyle: { width: "100%" },
                                attrs: { size: "small" },
                                model: {
                                  value: props.row.name,
                                  callback: function ($$v) {
                                    _vm.$set(props.row, "name", $$v)
                                  },
                                  expression: "props.row.name",
                                },
                              }),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "服务商图标",
                        prop: "categoryNo",
                        "min-width": "50",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              scope.row.mainImage == ""
                                ? _c(
                                    "el-upload",
                                    {
                                      ref: "upload",
                                      attrs: {
                                        action: "#",
                                        limit: 1,
                                        "on-exceed": _vm.test,
                                        "before-upload": _vm.beforeAvatarUpload,
                                        "http-request": (response) =>
                                          _vm.imgUpload(response, scope.$index),
                                        "file-list": _vm.fileListImg,
                                        "show-file-list": false,
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass:
                                          "el-icon-plus avatar-uploader-icon",
                                        staticStyle: { "font-size": "18px" },
                                      }),
                                    ]
                                  )
                                : _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        display: "inline-block",
                                        padding: "2px",
                                        "margin-right": "5px",
                                        position: "relative",
                                      },
                                    },
                                    [
                                      _c("img", {
                                        directives: [
                                          {
                                            name: "image-preview",
                                            rawName: "v-image-preview",
                                          },
                                        ],
                                        staticStyle: {
                                          width: "90px",
                                          height: "90px",
                                          "padding-top": "10px",
                                        },
                                        attrs: {
                                          src:
                                            _vm.ImgHttps + scope.row.mainImage,
                                        },
                                      }),
                                      _c("i", {
                                        staticClass: "el-icon-error",
                                        staticStyle: {
                                          position: "absolute",
                                          top: "3px",
                                          right: "-6px",
                                          cursor: "pointer",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.deleteImg(scope.$index)
                                          },
                                        },
                                      }),
                                    ]
                                  ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "升级条件",
                        prop: "amount",
                        "min-width": "50",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "header",
                          fn: function ({ column, $index }) {
                            return [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "align-items": "center",
                                  },
                                },
                                [
                                  _vm._v(" 升级条件 "),
                                  _c(
                                    "el-tooltip",
                                    {
                                      staticClass: "item",
                                      attrs: {
                                        effect: "dark",
                                        content:
                                          "设置一次性下单多少金额身份商品,可提升对应服务商身份等级",
                                        placement: "top",
                                      },
                                    },
                                    [
                                      _c("div", { staticClass: "tipsText" }, [
                                        _vm._v("?"),
                                      ]),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                        {
                          key: "default",
                          fn: function (props) {
                            return [
                              _c("el-input", {
                                staticStyle: { width: "80%" },
                                attrs: { size: "small" },
                                on: {
                                  input: (v) =>
                                    (props.row.amount = v.replace(
                                      /[^0-9.]/g,
                                      ""
                                    )),
                                },
                                model: {
                                  value: props.row.amount,
                                  callback: function ($$v) {
                                    _vm.$set(props.row, "amount", $$v)
                                  },
                                  expression: "props.row.amount",
                                },
                              }),
                              _c("span", { staticClass: "marginClass" }, [
                                _vm._v("元"),
                              ]),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "上级返佣",
                        prop: "commissionProportion",
                        "min-width": "50",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "header",
                          fn: function ({ column, $index }) {
                            return [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "align-items": "center",
                                  },
                                },
                                [
                                  _vm._v(" 上级返佣 "),
                                  _c(
                                    "el-tooltip",
                                    {
                                      staticClass: "item",
                                      attrs: {
                                        effect: "dark",
                                        content:
                                          "设置升级身份时，上级获得升级身份订单佣金比例",
                                        placement: "top",
                                      },
                                    },
                                    [
                                      _c("div", { staticClass: "tipsText" }, [
                                        _vm._v("?"),
                                      ]),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                        {
                          key: "default",
                          fn: function (props) {
                            return [
                              _c("el-input", {
                                staticStyle: { width: "80%" },
                                attrs: { size: "small" },
                                on: {
                                  input: (v) =>
                                    (props.row.commissionProportion = v.replace(
                                      /[^0-9.]/g,
                                      ""
                                    )),
                                },
                                model: {
                                  value: props.row.commissionProportion,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      props.row,
                                      "commissionProportion",
                                      $$v
                                    )
                                  },
                                  expression: "props.row.commissionProportion",
                                },
                              }),
                              _c("span", { staticClass: "marginClass" }, [
                                _vm._v("%"),
                              ]),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "粉丝返佣",
                        prop: "goodsCommissionProportion",
                        "min-width": "50",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "header",
                          fn: function ({ column, $index }) {
                            return [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "align-items": "center",
                                  },
                                },
                                [
                                  _vm._v(" 粉丝返佣 "),
                                  _c(
                                    "el-tooltip",
                                    {
                                      staticClass: "item",
                                      attrs: {
                                        effect: "dark",
                                        content:
                                          "设置该身份等级的下级用户购买普通商品时给予上级返佣比例,普通商品定义:秒杀商品、未达升级条件的身份商品、普通商品",
                                        placement: "top",
                                      },
                                    },
                                    [
                                      _c("div", { staticClass: "tipsText" }, [
                                        _vm._v("?"),
                                      ]),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                        {
                          key: "default",
                          fn: function (props) {
                            return [
                              _c("el-input", {
                                staticStyle: { width: "80%" },
                                attrs: { size: "small" },
                                on: {
                                  input: (v) =>
                                    (props.row.goodsCommissionProportion =
                                      v.replace(/[^0-9.]/g, "")),
                                },
                                model: {
                                  value: props.row.goodsCommissionProportion,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      props.row,
                                      "goodsCommissionProportion",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "props.row.goodsCommissionProportion",
                                },
                              }),
                              _c("span", { staticClass: "marginClass" }, [
                                _vm._v("%"),
                              ]),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "升级返现（积分）",
                        prop: "points",
                        "min-width": "50",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "header",
                          fn: function ({ column, $index }) {
                            return [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "align-items": "center",
                                  },
                                },
                                [
                                  _vm._v(" 升级返现（积分） "),
                                  _c(
                                    "el-tooltip",
                                    {
                                      staticClass: "item",
                                      attrs: {
                                        effect: "dark",
                                        content:
                                          "设置升级对应身份获得的积分奖励",
                                        placement: "top",
                                      },
                                    },
                                    [
                                      _c("div", { staticClass: "tipsText" }, [
                                        _vm._v("?"),
                                      ]),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                        {
                          key: "default",
                          fn: function (props) {
                            return [
                              _c("el-input", {
                                staticStyle: { width: "80%" },
                                attrs: { size: "small" },
                                on: {
                                  input: (v) =>
                                    (props.row.points = v.replace(
                                      /[^0-9.]/g,
                                      ""
                                    )),
                                },
                                model: {
                                  value: props.row.points,
                                  callback: function ($$v) {
                                    _vm.$set(props.row, "points", $$v)
                                  },
                                  expression: "props.row.points",
                                },
                              }),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "自购返佣",
                        prop: "vipDiscount",
                        "min-width": "50",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "header",
                          fn: function ({ column, $index }) {
                            return [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "align-items": "center",
                                  },
                                },
                                [
                                  _vm._v(" 自购返佣 "),
                                  _c(
                                    "el-tooltip",
                                    {
                                      staticClass: "item",
                                      attrs: {
                                        effect: "dark",
                                        content:
                                          "设置该身份等级自身购买普通商品的返佣比例,普通商品定义: 秒杀商品、未达升级条件的身份商品、普通商品",
                                        placement: "top",
                                      },
                                    },
                                    [
                                      _c("div", { staticClass: "tipsText" }, [
                                        _vm._v("?"),
                                      ]),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                        {
                          key: "default",
                          fn: function (props) {
                            return [
                              _c("el-input", {
                                staticStyle: { width: "80%" },
                                attrs: { size: "small" },
                                on: {
                                  input: (v) =>
                                    (props.row.vipDiscount = v.replace(
                                      /[^0-9.]/g,
                                      ""
                                    )),
                                },
                                model: {
                                  value: props.row.vipDiscount,
                                  callback: function ($$v) {
                                    _vm.$set(props.row, "vipDiscount", $$v)
                                  },
                                  expression: "props.row.vipDiscount",
                                },
                              }),
                              _c("span", { staticClass: "marginClass" }, [
                                _vm._v("%"),
                              ]),
                              _c("div", [_vm._v("身份服务商购买商品返佣")]),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "同级补贴",
                        prop: "sameLevelSubsidy",
                        "min-width": "50",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (props) {
                            return [
                              _c("el-input", {
                                staticStyle: { width: "80%" },
                                attrs: { size: "small" },
                                on: {
                                  input: (v) =>
                                    (props.row.sameLevelSubsidy = v.replace(
                                      /[^0-9.]/g,
                                      ""
                                    )),
                                },
                                model: {
                                  value: props.row.sameLevelSubsidy,
                                  callback: function ($$v) {
                                    _vm.$set(props.row, "sameLevelSubsidy", $$v)
                                  },
                                  expression: "props.row.sameLevelSubsidy",
                                },
                              }),
                              _c("span", { staticClass: "marginClass" }, [
                                _vm._v("%"),
                              ]),
                              _c("div", [_vm._v("仅享受一级")]),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "说明",
                        prop: "remark",
                        "min-width": "50",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (props) {
                            return [
                              _c("el-input", {
                                staticStyle: { width: "80%" },
                                attrs: { size: "small", type: "textarea" },
                                model: {
                                  value: props.row.remark,
                                  callback: function ($$v) {
                                    _vm.$set(props.row, "remark", $$v)
                                  },
                                  expression: "props.row.remark",
                                },
                              }),
                            ]
                          },
                        },
                      ]),
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
          _c(
            "div",
            { staticClass: "submit" },
            [
              _c(
                "el-button",
                {
                  staticClass: "submit_btn",
                  attrs: { type: "primary" },
                  on: { click: _vm.submit },
                },
                [_vm._v("确 认")]
              ),
            ],
            1
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "inquiry" }, [
      _c("div", { staticClass: "headerbox" }, [
        _c("div", { staticClass: "header" }, [
          _c("div", { staticClass: "title_left" }),
          _vm._v(" 身份设置 "),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }